export default __webpack_public_path__ + "static/media/flag_zh.814b7a34.svg";